import React, { memo, FC, useEffect } from 'react'

import { FocusNode } from '@please/lrud'

import { useAutoHide } from '@/hooks/useAutoHide'
import { Keys } from '@/platform/platform'
import { AutoHideProps } from '@/types/componentsPropsTypes'
import { isPointerMode } from '@/utils/utils'

import { Fade, StyledAutoHide } from './styles'

const AutoHideRaw: FC<AutoHideProps> = ({
  children,
  options,
  onChange,
  show,
}) => {
  const { handlers } = useAutoHide({ show, onChange, options })

  useEffect(() => {
    const keyPressHandler = (e: KeyboardEvent | MouseEvent) => {
      const keyCode = e.type === 'keydown' ? (e as KeyboardEvent).keyCode : null
      const mediaKeys = new Set([
        Keys.MEDIA_PLAY,
        Keys.MEDIA_PAUSE,
        Keys.MEDIA_STOP,
        Keys.MEDIA_PLAY_PAUSE,
        Keys.MEDIA_REWIND,
        Keys.MEDIA_FAST_FORWARD,
      ])

      const isMediaKey = keyCode && mediaKeys.has(keyCode)
      if (isMediaKey || e.type === 'click') {
        handlers.onKeyDown()
      }
    }

    window.addEventListener('keydown', keyPressHandler, true)
    isPointerMode && window.addEventListener('click', keyPressHandler, true)
    return () => {
      window.removeEventListener('keydown', keyPressHandler, true)
      isPointerMode &&
        window.removeEventListener('click', keyPressHandler, true)
    }
  }, [handlers.onKeyDown])

  return (
    <StyledAutoHide
      onMouseMove={isPointerMode ? handlers.onMouseMove : () => {}}
      onMouseLeave={isPointerMode ? handlers.onMouseLeave : () => {}}
      onMouseEnter={isPointerMode ? handlers.onMouseEnter : () => {}}
    >
      <FocusNode
        focusId="hide_controls"
        onArrow={handlers.onKeyDown}
        onSelected={handlers.onKeyDown}
      >
        <Fade $show={show}>{children}</Fade>
      </FocusNode>
    </StyledAutoHide>
  )
}

export const AutoHide = memo(AutoHideRaw)
